import React, { useEffect } from "react";
import styles from "@/components/modal/license-limited-modals/styles/license-limited-modal.module.scss";
import { LicenseName } from "@/data/license.data";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useRouter } from "next/navigation";
import Link from "next/link";
import GetFreeAccessButton from "@/components/common/get-free-access-button";

type TrialFileLimitationsModalProps = {
  licenseName: LicenseName;
  limitationType: "size" | "duration";
  limit: number;
};

const FileLimitedModal = ({
  licenseName,
  limitationType,
  limit,
}: TrialFileLimitationsModalProps) => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();
  useEffect(() => {
    if (licenseName === "Trial") {
      router.push("/pricing");
    }
  }, [licenseName, router]);

  const limitMessage =
    limitationType === "size" ? `${limit} MB` : `${limit} minutes`;

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> {licenseName.toLowerCase()} version of
        AudioModify!
      </div>
      <div className={styles.sub_container}>
        <div>
          {licenseName === "Trial"
            ? "You have reached file size limit for the Trial version of our app!"
            : "To increase limits please contact support@audiomodify.com"}
        </div>
        <div>
          {licenseName === "Trial"
            ? `Please upgrade to the paid version to generate AI covers for songs longer than ${limitMessage}`
            : `Maximum duration of audio file is ${limitMessage}`}
        </div>
        <br />
        30% off only today with discount code &quot;cover&quot;
      </div>
      <GetFreeAccessButton />
      {licenseName === "Trial" && (
        <IncreaseLimitsButton filled={true} onClick={hideModal} />
      )}
    </div>
  );
};

export default FileLimitedModal;
